export const PlacementMode = {
  AUTO: 'placement_auto',
  MANUAL: 'placement_manual'
};
